import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

type IRequestId = {
  requestedAt: string;
  isLoaded: boolean;
};

const initialState: IRequestId = {
  requestedAt: "",
  isLoaded: false,
};

const requestIdSlice = createSlice({
  name: "request-id",
  initialState,
  reducers: {
    updateRequestedAt: (state, action: PayloadAction<IRequestId>) => {
      state.requestedAt = action.payload.requestedAt;
      state.isLoaded = action.payload.isLoaded;
    },
  },
});

export const { updateRequestedAt } = requestIdSlice.actions;

export default requestIdSlice.reducer;
